import PageTypeFactory from '../../page/get_page_type';
import GA_EVENTS from './ga_constants';
import { setBehaviourEvent } from './ga_interface';
import { setBehaviourEvent as setFunnelyticsBehaviourEvent } from '../funnelytic_analytics/funnelytics_interface';

class CatalogConfiguratorAnalytics {
    static openAction() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.open;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static submitAction() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.submit;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static openFromConfiguratorLayer(isMoto) {
        const category = isMoto ? GA_EVENTS.catalogConfigurator.motoTyreSizeTitle : GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.showSizeConfiguratorLayer;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static closeAction() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.close;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static goToFirstLayerAction() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.goToFirstLayer;
        const label = PageTypeFactory.getPageType();
        
        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static goToFormAction() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.goToForm;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static clickShowMeAllProducts() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.showMeAllProducts;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static showInfoAction() {
        const category = GA_EVENTS.catalogConfigurator.tyreSizeTitle;
        const action = GA_EVENTS.catalogConfigurator.actions.showInfo;
        const label = PageTypeFactory.getPageType();

        setBehaviourEvent({ category, action, label });
        setFunnelyticsBehaviourEvent({ category, action, label });
    }

    static setWidthAction(width, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.setWidth;

        setBehaviourEvent({ category, action, label: width });
        setFunnelyticsBehaviourEvent({ category, action, label: width });
    }

    static setHeightAction(height, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.setHeight;

        setBehaviourEvent({ category, action, label: height });
        setFunnelyticsBehaviourEvent({ category, action, label: height });
    }

    static setDiameterAction(diameter, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.setDiameter;

        setBehaviourEvent({ category, action, label: diameter });
        setFunnelyticsBehaviourEvent({ category, action, label: diameter });
    }

    static setLoadIndexAction(loadIndex, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.setLoadIndex;

        setBehaviourEvent({ category, action, label: loadIndex });
        setFunnelyticsBehaviourEvent({ category, action, label: loadIndex });
    }

    static setSpeedIndexAction(speedIndex, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.setSpeedIndex;

        setBehaviourEvent({ category, action, label: speedIndex });
        setFunnelyticsBehaviourEvent({ category, action, label: speedIndex });
    }

    static setPostcodeAction(postcode, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.setPostcode;

        setBehaviourEvent({ category, action, label: postcode });
        setFunnelyticsBehaviourEvent({ category, action, label: postcode });
    }

    static noProductsFoundAction(appliedFilters, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.noProductsFound;

        setBehaviourEvent({ category, action, label: appliedFilters });
        setFunnelyticsBehaviourEvent({ category, action, label: appliedFilters });
    }

    static productsFoundAfterNoneWereFoundAction(appliedFilters, productType) {
        const category = this.getValidTyreSizeName(productType);
        const action = GA_EVENTS.catalogConfigurator.actions.productsFoundAgain;

        setBehaviourEvent({ category, action, label: appliedFilters });
        setFunnelyticsBehaviourEvent({ category, action, label: appliedFilters });
    }

    static getValidTyreSizeName(type) {
        return type === 'tyre_moto' ? GA_EVENTS.catalogConfigurator.motoTyreSizeTitle : GA_EVENTS.catalogConfigurator.tyreSizeTitle;
    }
}

export default CatalogConfiguratorAnalytics;